import React from 'react'
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom"
// import { CadenasPage } from './cadenas/CadenasPage';
import { SolicitudesEjecutadasAdminPage } from './admin/SolicitudesEjecutadasAdminPage';
import { SolicitudesEjecutadasDetailPage } from './detail/SolicitudesEjecutadasDetailPage';
import SolicitudesEjecutadasResultadoPage from './detail/SolicitudesEjecutadasResultadoPage';

const SolicitudesEjecutadasRoutes = () => {
  const { path } = useRouteMatch();
  const history = useHistory()

  return (
    <Switch>
      <Route path={`${path}/solicitudes-ejecutadas/resultados/:id`} render={(props) => (<SolicitudesEjecutadasResultadoPage {...props} history={history} />)} />
      <Route path={`${path}/solicitudes-ejecutadas-admin`} component={SolicitudesEjecutadasAdminPage} />
      <Route path={`${path}/solicitudes-ejecutadas/:id`} component={SolicitudesEjecutadasDetailPage} />
    </Switch>
  )
}
export default SolicitudesEjecutadasRoutes;
